"use client";

import { ClickableLocationInfo } from "@/components/discover/ClickableLocationInfo";
import { InfoItem } from "@/components/discover/InfoItem";
import { formatDetailedEventDates, resolveEventRange } from "@/utils/date";
import { Calendar, MapPin } from "lucide-react";

export function EventMeta(props: {
  startDate: string;
  endDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  timeZone?: string;
  locationName: string;
  city?: string | null;
  dateLabel: string;
  locationLabel: string;
  locale?: string;
}) {
  const range = resolveEventRange({
    startDate: props.startDate,
    endDate: props.endDate,
    startTime: props.startTime,
    endTime: props.endTime,
  });

  return (
    <>
      <InfoItem icon={Calendar} label={props.dateLabel}>
        {formatDetailedEventDates({
          locale: props.locale || "en-gb",
          start: range.start,
          end: range.end,
          includeTime: range.includeTime,
          timeZone: props.timeZone,
        })}
      </InfoItem>
      <ClickableLocationInfo icon={MapPin} label={props.locationLabel}>
        {props.locationName}
        {props.city ? `, ${props.city}` : ""}
      </ClickableLocationInfo>
    </>
  );
}
